<template>
  <md-empty-state
    class="md-primary"
    md-icon="cloud_off"
    md-label="Não foi possível carregar"
    md-description="Algum problema aconteceu no carregamento deste bloco, por favor tente novamente.">
    <md-button @click="$emit('handleButton')" class="md-primary md-raised">Tentar Novamente</md-button>
  </md-empty-state>
</template>

<script>
  export default {
    name: "ErrorContentPage"
  }
</script>

<style scoped>

</style>
